import Swiper, { Scrollbar, Mousewheel, Lazy, Controller } from "swiper";
Swiper.use([Scrollbar, Mousewheel, Lazy, Controller]);

export default class SliderMedia {
  constructor() {
    this.slidesNodes = $(".c-slider-media");
    this.sliders = [];

    this.setupSliders = this.setupSliders.bind(this);
  }

  init() {
    this.setupSliders();
  }

  setupSliders() {
    this.slidesNodes.each(index => {
      this.sliders.push(
        new Swiper(".js-slider-media-" + index, {
          loop: false,
          lazy: true,
          watchSlidesVisibility: true,
          slidesPerView: "auto",
          containerModifierClass: "c-slider-media-",
          slideClass: "c-slider-media__slide",
          slideActiveClass: "-active",
          slideVisibleClass: "-visible",
          slideNextClass: "-next",
          slidePrevClass: "-prev",
          wrapperClass: "c-slider-media__wrapper",
          preventClicksPropagation: false,
          scrollbar: {
            el: ".js-carousel-scrollbar-" + index,
            hide: false,
          },
        })
      );
    });
  }

  // events() {
  //   this.links.forEach(el => {
  //     el.addEventListener("click", this.copyLink);
  //   });
  // }
}



// WEBPACK FOOTER //
// ./scripts/components/sliderMedia.js